import { useState } from "react";
import TopSection from "../../LT/TopSection";
import AlertCards from "./AlertCards";

const AlertsPage = () => {

    const alertData = [{
        id:1,
        type: "info",
        title: "New Forecast Published",
        alertDate: "2024-06-01",
        description: "This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 This is the description for Alert 1 "
    },
    {
        id:2,
        type: "warning",
        title: "SLA Warning: Confirmation Due",
        alertDate: "2024-06-02",
        description: "This is the description for Alert 2 This is the description for Alert 2 This is the description for Alert 2 This is the description for Alert 2 This is the description for Alert 2 This is the description for Alert 2"
    },
    {
        id:3,
        type: "info",
        title: "New Forecast Published",
        alertDate: "2024-06-01",
        description: "This is the description for Alert 1"
    },
    {
        id:4,
        type: "warning",
        title: "SLA Warning: Confirmation Due",
        alertDate: "2024-06-02",
        description: "This is the description for Alert 2"
    },
    {
        id:5,
        type: "info",
        title: "New Forecast Published",
        alertDate: "2024-06-01",
        description: "This is the description for Alert 1"
    },
    {
        id:6,
        type: "warning",
        title: "SLA Warning: Confirmation Due",
        alertDate: "2024-06-02",
        description: "This is the description for Alert 2"
    }]

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Alerts" },
                ]}
                tabTitle="Alerts"
            />
            <div style={{margin:10}}>
                {alertData?.map((alert) => (
                    <div style={{ gap: 10, marginBottom: 10 }}>
                        <AlertCards alertData={alert} />
                    </div>
                ))}
            </div>

        </div>
    )
}

export default AlertsPage;